import { useTheme } from '@emotion/react';
import Box from '@mui/material/Box';
import Text from '@Text';
import { shouldRenderContent } from './thankYouPage.helpers';
import useGetExperimentName from '../../Hooks/useGetExperimentName/useGetExperimentName';

const ThankYouSection = ({ question, text, idText, id }) => {
  const theme = useTheme();
  const textExperimentName = useGetExperimentName({
    componentName: 'Text',
  });

  return (
    <>
      <Text
        variant="question"
        experimentName={textExperimentName}
        dataTestId="thankYouSectionQuestion"
      >
        {question}
      </Text>
      <Text
        variant="text"
        experimentName={textExperimentName}
        dataTestId="thankYouSectionText"
      >
        {text}
      </Text>
      {shouldRenderContent(idText) && (
        <Box
          marginTop={theme.mvf.spacing.tiny}
          fontWeight={theme.mvf.typography.weight.thick}
        >
          <Text
            variant="text"
            experimentName={textExperimentName}
            dataTestId="thankYouSectionIdText"
          >
            {idText}{' '}
            <strong data-testid="thankYouSectionSubmissionId">{id}</strong>
          </Text>
        </Box>
      )}
    </>
  );
};

export default ThankYouSection;
